const {
  name
} = require('../../package.json');

export function calcSubPath() {
  return `/${name.split('-').map(value => value.charAt(0)).join('')}/`;
}